import { type Price, PriceInterval } from '@/types';

import { currencyFormatter } from '../utils/currencyFormatter';

// "Pay $X" for what the reader is charged today: a donation's chosen amount, or a paid trial's trial price.
export const payCta = (price: Price | undefined, donationAmountCents: number) => {
  if (!price) return 'Submit';

  const isDonation = price.interval === PriceInterval.DONATION;
  const isPaidTrial = price.premium_offer?.offer_type === 'paid_trial';
  const amountCents =
    (isDonation
      ? donationAmountCents
      : isPaidTrial && price.premium_offer?.paid_trial_price_cents != null
        ? price.premium_offer.paid_trial_price_cents
        : price.amount_cents) || 0;

  return `Pay ${currencyFormatter({ value: amountCents / 100, currency: price.currency })}`;
};
